import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  alert: {
    position: 'fixed',
    minWidth: '350px',
    marginTop: '10px',
    left: 'calc(50% - 175px)',
    right: '50%',
    background: 'var(--color-white) 0% 0% no-repeat padding-box',
    borderRadius: '5px',
    boxShadow: '0px 3px 15px #00000029',
    zIndex: '1999',
  },
  colorInfo: {
    borderLeft: '5px solid #777777',
    color: '#777777',
  },
  colorError: {
    borderLeft: '5px solid #FD4F59',
    color: '#FD4F59',
  },
  colorSuccess: {
    borderLeft: '5px solid #00D027',
    color: '#00D027',
  },
  colorWarning: {
    borderLeft: '5px solid #F8AC00',
    color: '#F8AC00',
  },
}));

export default useStyles;
